<template>
  <div
    :class="{
      'main-panel-desktop': $mq !== 'xs' && $mq !== 'sm' && $mq !== 'md'
    }"
    class="pl-2 pr-1"
  >
    <v-layout row>
      <v-layout row wrap class="align-start">
        <div>
          <div class="display-1">
            {{ projectName }}
          </div>
          <a
            style="
              display: block;
              color: black;
              text-decoration: underline !important;
            "
            :href="`${extUrl}/leases/project/${current._id}`"
            target="_blank"
          >
            {{ current._id }}
          </a>
          <a
            v-if="current.companyId"
            style="
              display: block;
              color: black;
              text-decoration: underline !important;
            "
            :href="`/prospect/${current.companyId}`"
            target="_blank"
          >
            {{ current.company }}
          </a>
        </div>
        <div :class="{ 'ml-5': $mq !== 'sm' && $mq !== 'md' }">
          <div>
            <v-icon size="1.4rem" color="primary">mail</v-icon>
            {{ current.userId }}
          </div>
          <div>
            <v-icon size="1.4rem" color="primary">phone</v-icon>
            {{ current.phoneNumber }}
          </div>
        </div>
      </v-layout>
      <div>
        <v-layout row wrap justify-space-between align-center>
          <v-btn
            class="mb-3"
            color="blue"
            v-if="nextColumn === 'awaitingSignature'"
            :disabled="!complete"
            style="width: auto; margin: 0; height: 50px; color: white; flex-grow: 0; flex-basis: 100%; font-size: .875rem;"
            @click="displayValidationDialog"
          >
            Proposer à la signature
            <v-icon class="ml-3">send</v-icon>
          </v-btn>
          <v-btn
            class="mb-3"
            color="blue"
            style="width: auto; margin: 0; height: 50px; color: white; flex-grow: 0; flex-basis: 100%; font-size: .875rem;"
            @click="$emit('update', nextColumn)"
            v-if="nextColumnAllowed && nextColumn !== 'awaitingSignature'"
            :disabled="
              ((nextColumn === 'toAssign' || nextColumn === 'docsLease') &&
                !complete) ||
                (nextColumn === 'submittedToHil' && !canSubmit)
            "
          >
            Passer en "{{ columnName(nextColumn) }}"
            <v-icon class="ml-3">send</v-icon>
          </v-btn>
        </v-layout>
      </div>
      <v-btn
        fixed
        dark
        fab
        class="hil-fab"
        color="accent"
        @click="$emit('displayFloatingWindows')"
        v-if="$mq === 'sm' || $mq === 'xs'"
      >
        <v-icon>chat</v-icon>
      </v-btn>
    </v-layout>
    <div>
      <v-combobox
        multiple
        v-model="currentTags"
        prefix="Ajouter des tags"
        :items="tags.existing"
        :filter="filterTags"
        append-icon
        chips
        deletable-chips
        hide-selected
        hide-no-data
        class="tag-input"
        :search-input.sync="tags.search"
        @change="onTagChange"
        @blur="onTagChange"
        :disabled="!editMode"
        :readonly="!editMode"
      />
    </div>
    <v-dialog v-model="validationModalIsVisible" width="700" persistent>
      <v-card>
        <v-card-title>
          <div class="headline">
            Veuillez vérifier les informations du dossier
          </div>
          <div
            class="red--text font-weight-bold my-2"
            style="text-align: justify"
          >
            Si les informations sont incorrectes des frais supplémentaires
            seront imputés à votre rémunération
          </div>
        </v-card-title>
        <v-card-text>
          <h3>Projet</h3>
          <v-layout row wrap class="mt-2 mb-2 container">
            <v-flex xs4>
              Zone :<br />
              Adresse du travail :<br />
              Signature du bail :
            </v-flex>
            <v-flex xs8 class="text-no-wrap">
              <div>
                {{
                  current.zone &&
                    infoFields.projectinfos
                      .find(({ name }) => name === "zone")
                      .items.find(({ value }) => value === current.zone).text
                }}
              </div>
              <div>{{ current.addressWork }}</div>
              <div>{{ current.leaseSignDate | date }}</div>
            </v-flex>
          </v-layout>

          <h3>Locataire</h3>
          <v-layout row wrap class="mt-2 mb-2 container">
            <v-flex xs6>
              Civilité :<br />
              Prénom :<br />
              Nom :<br />
              Téléphone :<br />
              E-mail :<br />
              Date de naissance :<br />
              Lieu de naissance :<br />
              Département / pays de naissance :<br />
              Nationalité :<br />
              Situation familiale :<br />
              Nombre d'enfants :<br />
              Adresse de départ :<br />
              Statut habitation précédente :<br />
              Type de contrat :<br />
              Entreprise :<br />
              Siret de l'entreprise :<br />
              Nom de contact :<br />
              E-mail de contact :<br />
              Poste :<br />
              Début du contrat :
            </v-flex>
            <v-flex xs6 class="text-no-wrap">
              <div>{{ current.civility }}</div>
              <div>{{ current.firstName }}</div>
              <div>{{ current.lastName }}</div>
              <div>{{ current.phoneNumber }}</div>
              <div>{{ current.userId }}</div>
              <div>{{ current.dateOfBirth | date }}</div>
              <div>{{ current.placeOfBirth }}</div>
              <div>{{ current.deptOfBirth }}</div>
              <div>{{ current.nationality }}</div>
              <div>{{ current.familyStatus }}</div>
              <div>{{ current.childrenCount }}</div>
              <div>{{ current.actualCity }}</div>
              <div>{{ current.previousOwnerType }}</div>
              <div>{{ current.contractType }}</div>
              <div>{{ current.company }}</div>
              <div>{{ current.companySiret }}</div>
              <div>{{ current.companyContactName }}</div>
              <div>{{ current.companyMail }}</div>
              <div>{{ current.job }}</div>
              <div>{{ current.contractStartDate | date }}</div>
            </v-flex>
          </v-layout>

          <div v-if="current.coEnabled">
            <h3>Co-demandeur</h3>
            <v-layout row wrap class="mt-2 mb-2 container">
              <v-flex xs6>
                Civilité :<br />
                Prénom :<br />
                Nom :<br />
                Téléphone :<br />
                E-mail :<br />
                Date de naissance :<br />
                Lieu de naissance :<br />
                Département / pays de naissance :<br />
                Adresse de départ :<br />
              </v-flex>
              <v-flex xs6 class="text-no-wrap">
                <div>{{ current.coCivility }}</div>
                <div>{{ current.coFirstName }}</div>
                <div>{{ current.coLastName }}</div>
                <div>{{ current.coPhoneNumber }}</div>
                <div>{{ current.coEmail }}</div>
                <div>{{ current.coDateOfBirth | date }}</div>
                <div>{{ current.coPlaceOfBirth }}</div>
                <div>{{ current.coDeptOfBirth }}</div>
                <div>{{ current.coAddress }}</div>
              </v-flex>
            </v-layout>
          </div>

          <p
            class="font-weight-bold red--text title"
            style="text-align: center"
          >
            En cliquant sur le bouton "Valider" ci-dessous, je certifie que les
            informations du dossier sont correctes.
          </p>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn color="primary" flat @click="moveToNextColumn">
            Valider
          </v-btn>
          <v-btn flat @click="closeValidationDialog">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getInfoFields } from "@/data/leaseData";
import { fetchHil2 } from "@/utils";
import { toRegex } from "diacritic-regex";
import * as _ from "lodash";
import { mapState } from "vuex";
import { EXTERNAL_URL } from "../../../../webapp-commons/config";
import { COLUMNS_NAMES } from "../../data/DefaultSettings";

export default {
  name: "ProjectHeader",
  props: [
    "nextColumn",
    "nextColumnAllowed",
    "complete",
    "canSubmit",
    "editMode"
  ],
  data() {
    return {
      infoFields: getInfoFields(),
      extUrl: EXTERNAL_URL,
      validationModalIsVisible: false,
      tags: {
        existing: [],
        search: ""
      }
    };
  },
  async mounted() {
    await this.fetchTags();
  },
  computed: {
    ...mapState("projects", ["current"]),
    projectName() {
      return (
        [this.current.firstName, this.current.lastName]
          .filter(Boolean)
          .join(" ") || "-"
      );
    },
    currentTags: {
      get() {
        return this.current.tags || [];
      },
      set(value) {
        this.current.tags = value;
      }
    },
    searchTagRegex() {
      if (!this.tags.search) {
        return /./;
      }
      return toRegex({ flags: "i" })(_.escapeRegExp(this.tags.search));
    }
  },
  methods: {
    columnName(columnId) {
      return COLUMNS_NAMES[columnId];
    },
    async fetchTags() {
      this.tags.existing = await fetchHil2("get", "/lease/tags");
    },
    filterTags(item, queryText, itemText) {
      return this.searchTagRegex.test(itemText);
    },
    onTagChange() {
      this.tags.search = "";
    },
    displayValidationDialog() {
      this.validationModalIsVisible = true;
    },
    closeValidationDialog() {
      this.validationModalIsVisible = false;
    },
    moveToNextColumn() {
      this.$emit("update", this.nextColumn);
      this.validationModalIsVisible = false;
    }
  }
};
</script>

<style scoped></style>
